<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            <strong>
                             ATA DIREX
                             {{ ataDirex.nuAtaDirex }} -
                             {{ataDirex.tipoAta}} -
                             {{ ataDirex.dtReuniao ? $moment(ataDirex.dtReuniao).format(
                                      'DD/MM/YYYY'
                                  )
                              : '' }} -
                                {{ ataDirex.situacaoAta}}
                            </strong>
                            <b-badge variant="warning" class="ml-2">{{
                                operacao
                            }}</b-badge>
                        </span>
                    </b-card-header>

                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>

                        <b-tabs pills card vertical v-model="tabIndex">
                            <b-tab title="Dados Cadastrais" class="pb-0">
                                <App-Dados-Cadastrais
                                    v-if="$temAcessoView('ATADIREX-00')"
                                    :ataDirex="ataDirex"
                                ></App-Dados-Cadastrais>
                            </b-tab>
                            <b-tab title="Processos" class="pb-0">
                                <App-Processos-Ata
                                    v-if="$temAcessoView('ATADIREX-05')"
                                ></App-Processos-Ata>

                            </b-tab>
                        </b-tabs>
                    </b-card-body>

                    <b-card-footer>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import AtaDirexServicos from '../AtaDirexServicos'
    import AtaDirexDadosCadastrais from './AtaDirexDadosCadastrais.vue'
    import ProcessosAta from '../ProcessosAtaDirex.vue'

    export default {
        components: {
            AppDadosCadastrais: AtaDirexDadosCadastrais,
            AppProcessosAta: ProcessosAta
        },

        data() {
            return {
                mostrarModal: false,
                ataDirex: {},
                operacao: 'DETALHES',
                tabIndex: this.$route.params.tabindex,
                erros: [],
            }
        },

        methods: {
            voltar() {
                this.$router.push({ name: 'AtasDirex' })
            },

            obterAtaDirex() {
                this.$store.dispatch('addRequest')
                AtaDirexServicos.ObterPorId(this.$route.params.idAtaDirex).then(
                    response => {
                        if (response) {
                            if (response.success) {
                                this.ataDirex = response.data
                            } else {
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    }
                )
            },
        },

        created() {
            this.obterAtaDirex()
         },
    }
</script>

